// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Rectangle 2.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FaceToFaceSection_faceSection__cJlDf {
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover; /* Ensure the image covers the entire section */
  background-repeat: no-repeat;
  background-size: 1612px 576px;
}

.FaceToFaceSection_imageContainer__OD4w8 {
  position: relative;
  flex: 1 1;
}

.FaceToFaceSection_faceImage__-6xYE {
  height: 700px;
  width: 600px;
}

.FaceToFaceSection_textContent__6-I\\+4 {
  flex: 1 1;
  margin-top: 3rem;
  margin-left: 2rem;
}

.FaceToFaceSection_textContent__6-I\\+4 h2 {
  font-size: 36px;
  font-weight: 500;
  color: #1d2939;
  font-family: Poppins;
}

.FaceToFaceSection_highlight__h\\+W3Y {
  color: #FF6500;
}

.FaceToFaceSection_textContent__6-I\\+4 p {
  font-size: 1rem;
  color: #555;
  /* margin-top: 10px; */
}
@media (min-width: 300px) and (max-width: 400px) {
  .FaceToFaceSection_textContent__6-I\\+4 {
    flex: 1 1;
    margin-top: 0rem;
    margin-left: 1rem;
  }
  .FaceToFaceSection_faceSection__cJlDf {
    width: 371px;
  }
  .FaceToFaceSection_faceImage__-6xYE {
    display: none;
  }
  .FaceToFaceSection_hideOnSmall__rdnF5 {
    display: none;
  }
  .FaceToFaceSection_faceSection__cJlDf {
    /* background-color: black; */
    background-image: none;
    margin-bottom: 14px;
  }
  .FaceToFaceSection_imageContainer__OD4w8 {
    flex: 0 1;
    flex-basis: auto;
    /* flex-basis: auto; */
  }

}
@media (min-width: 400px) and (max-width: 600px) {
  .FaceToFaceSection_imageContainer__OD4w8 {
    flex: 0 1;
    flex-basis: auto;
    /* flex-basis: auto; */
  }
  .FaceToFaceSection_faceSection__cJlDf {
    /* background-color: black; */
    background-image: none;
    margin-bottom: 14px;
  }
  .FaceToFaceSection_faceImage__-6xYE {
    display: none;
  }
  .FaceToFaceSection_textContent__6-I\\+4 {
    flex: 1 1;
    margin-top: 0rem;
    margin-left: 2rem;
  }
  .FaceToFaceSection_faceSection__cJlDf {
    width: 420px;
  }
  .FaceToFaceSection_hideOnSmall__rdnF5 {
    display: none;
  }
}

@media (min-width: 600px) and (max-width: 912px) {
  .FaceToFaceSection_faceSection__cJlDf {
    /* background-color: black; */
    background-image: none;
    margin-bottom: 14px;
    margin-left: 14px;
  }
  .FaceToFaceSection_imageContainer__OD4w8 {
    flex: 0 1;
  }
  .FaceToFaceSection_faceImage__-6xYE {
    display: none;
    /* height: 550px; */
    /* position:absolute; */
    /* width: 420px; */
  }
  .FaceToFaceSection_hideOnSmall__rdnF5 {
    display: none;
  }
  .FaceToFaceSection_textContent__6-I\\+4 {
    margin-right: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/FaceToFaceSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yDAAmD;EACnD,sBAAsB,EAAE,+CAA+C;EACvE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA;EACE;IACE,SAAO;IACP,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,SAAO;IACP,gBAAgB;IAChB,sBAAsB;EACxB;;AAEF;AACA;EACE;IACE,SAAO;IACP,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,SAAO;IACP,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,SAAO;EACT;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".faceSection {\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  background-image: url(\"../images/Rectangle\\ 2.svg\");\n  background-size: cover; /* Ensure the image covers the entire section */\n  background-repeat: no-repeat;\n  background-size: 1612px 576px;\n}\n\n.imageContainer {\n  position: relative;\n  flex: 1;\n}\n\n.faceImage {\n  height: 700px;\n  width: 600px;\n}\n\n.textContent {\n  flex: 1;\n  margin-top: 3rem;\n  margin-left: 2rem;\n}\n\n.textContent h2 {\n  font-size: 36px;\n  font-weight: 500;\n  color: #1d2939;\n  font-family: Poppins;\n}\n\n.highlight {\n  color: #FF6500;\n}\n\n.textContent p {\n  font-size: 1rem;\n  color: #555;\n  /* margin-top: 10px; */\n}\n@media (min-width: 300px) and (max-width: 400px) {\n  .textContent {\n    flex: 1;\n    margin-top: 0rem;\n    margin-left: 1rem;\n  }\n  .faceSection {\n    width: 371px;\n  }\n  .faceImage {\n    display: none;\n  }\n  .hideOnSmall {\n    display: none;\n  }\n  .faceSection {\n    /* background-color: black; */\n    background-image: none;\n    margin-bottom: 14px;\n  }\n  .imageContainer {\n    flex: 0;\n    flex-basis: auto;\n    /* flex-basis: auto; */\n  }\n\n}\n@media (min-width: 400px) and (max-width: 600px) {\n  .imageContainer {\n    flex: 0;\n    flex-basis: auto;\n    /* flex-basis: auto; */\n  }\n  .faceSection {\n    /* background-color: black; */\n    background-image: none;\n    margin-bottom: 14px;\n  }\n  .faceImage {\n    display: none;\n  }\n  .textContent {\n    flex: 1;\n    margin-top: 0rem;\n    margin-left: 2rem;\n  }\n  .faceSection {\n    width: 420px;\n  }\n  .hideOnSmall {\n    display: none;\n  }\n}\n\n@media (min-width: 600px) and (max-width: 912px) {\n  .faceSection {\n    /* background-color: black; */\n    background-image: none;\n    margin-bottom: 14px;\n    margin-left: 14px;\n  }\n  .imageContainer {\n    flex: 0;\n  }\n  .faceImage {\n    display: none;\n    /* height: 550px; */\n    /* position:absolute; */\n    /* width: 420px; */\n  }\n  .hideOnSmall {\n    display: none;\n  }\n  .textContent {\n    margin-right: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faceSection": `FaceToFaceSection_faceSection__cJlDf`,
	"imageContainer": `FaceToFaceSection_imageContainer__OD4w8`,
	"faceImage": `FaceToFaceSection_faceImage__-6xYE`,
	"textContent": `FaceToFaceSection_textContent__6-I+4`,
	"highlight": `FaceToFaceSection_highlight__h+W3Y`,
	"hideOnSmall": `FaceToFaceSection_hideOnSmall__rdnF5`
};
export default ___CSS_LOADER_EXPORT___;
